/* ════════════════════════════════════════════════════════════════
   POSTERARTE · posterarte.nav.js
   Navigation JS — cart drawer · cart count sync · fetch intercept
   Dawn 14+ · Shopify · June 2026
   ════════════════════════════════════════════════════════════════ */

(function () {
  'use strict';

  /* ── GUARD: prevent double execution when script loads twice ─── */
  if (window._paNavLoaded) return;
  window._paNavLoaded = true;

  /* ── CART COUNT ──────────────────────────────────────────────── */
  async function refreshCartCount() {
    try {
      const r = await fetch('/cart.js', { headers: { 'Content-Type': 'application/json' } });
      const cart = await r.json();
      const count = cart.item_count;
      document.querySelectorAll('.pa-cart-count').forEach(function (el) {
        el.textContent = count > 0 ? count : '';
        el.dataset.count = count;
        el.style.display = count > 0 ? '' : 'none';
      });
    } catch (e) {}
  }

  /* ── DAWN CART EVENTS (all known variants) ───────────────────── */
  [
    'cart:change', 'cart:changed',
    'cart:update', 'cart:updated',
    'cart:refresh',
    'cart:item-added', 'cart:item:added'
  ].forEach(function (evt) {
    document.addEventListener(evt, function () {
      refreshCartCount();
    });
  });

  // Also listen on the cart-drawer element itself (Dawn fires events on it directly)
  var cartDrawerEl = document.querySelector('cart-drawer');
  if (cartDrawerEl) {
    cartDrawerEl.addEventListener('cart:refresh', refreshCartCount);
  }

  /* ── FETCH INTERCEPT — catches ATC at network level ──────────── */
  /* .bind(window) fixes "Illegal invocation" in strict mode:
     standalone fetch() calls have this=undefined in strict scope  */
  var _fetch = window.fetch.bind(window);
  window.fetch = function () {
    var url = (typeof arguments[0] === 'string' ? arguments[0] : (arguments[0] && arguments[0].url) || '') || '';
    var promise = _fetch.apply(window, arguments);
    if (url.includes('/cart/add')) {
      promise.then(function (response) {
        if (response.ok) {
          response.clone().json().then(function () {
            refreshCartCount();
          }).catch(function () { refreshCartCount(); });
        }
        return response;
      });
    }
    if (url.includes('/cart/change') || url.includes('/cart/clear')) {
      promise.then(function (response) {
        if (response.ok) {
          /* setTimeout(0) defers to a new macrotask — fully after Dawn has
             finished processing its /cart/change response in the current
             microtask batch. This avoids the race that caused
             "Hubo un error al actualizar tu carrito" while still
             keeping the nav count bubble in sync. */
          setTimeout(refreshCartCount, 0);
        }
      });
    }
    return promise;
  };

  /* Event delegation — document always exists, survives section re-renders */
  document.addEventListener('click', function (e) {
    if (e.target.closest('.pa-cart-btn')) {
      var cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer) cartDrawer.open();
    }
  });

  /* ── SHIPPING PROGRESS BAR ──────────────────────────────────── */
  /* Dawn's renderContents() and CartDrawerItems both replace       */
  /* #CartDrawer / .drawer__inner innerHTML entirely, destroying    */
  /* any injected nodes. Strategy:                                  */
  /*  1. MutationObserver on #CartDrawer childList — re-inject      */
  /*     whenever Dawn adds .drawer__header as a direct child       */
  /*  2. MutationObserver on <cart-drawer> class — re-inject when   */
  /*     'active' is added (drawer opened without cart change)      */
  (function () {
    var FREE_SHIPPING_THRESHOLD = 3900; // in cents

    function injectBar() {
      var header = document.querySelector('#CartDrawer .drawer__header');
      if (!header) return;
      var bar = document.createElement('div');
      bar.id = 'pa-shipping-bar';
      bar.className = 'pa-shipping-bar is-hidden';
      bar.innerHTML =
        '<p class="pa-shipping-bar__msg"></p>' +
        '<div class="pa-shipping-bar__track"><div class="pa-shipping-bar__fill"></div></div>';
      header.insertAdjacentElement('afterend', bar);
    }

    function updateBar() {
      var bar = document.getElementById('pa-shipping-bar');
      if (!bar) return;
      _fetch('/cart.js', { headers: { 'Content-Type': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var total = cart.total_price;
          var msg   = bar.querySelector('.pa-shipping-bar__msg');
          var fill  = bar.querySelector('.pa-shipping-bar__fill');
          if (total === 0) { bar.classList.add('is-hidden'); return; }
          bar.classList.remove('is-hidden');
          if (total >= FREE_SHIPPING_THRESHOLD) {
            msg.className = 'pa-shipping-bar__msg is-complete';
            msg.innerHTML = '<span class="pa-shipping-bar__check" aria-hidden="true">✓</span> ¡Envío gratuito aplicado!';
            fill.style.width = '100%';
          } else {
            var cents     = FREE_SHIPPING_THRESHOLD - total;
            var euros     = cents / 100;
            var formatted = euros % 1 === 0
              ? euros.toFixed(0)
              : euros.toFixed(2).replace('.', ',');
            msg.className = 'pa-shipping-bar__msg';
            msg.innerHTML = 'Te faltan <strong>' + formatted + '€</strong> para el envío gratuito';
            fill.style.width = (total / FREE_SHIPPING_THRESHOLD * 100).toFixed(1) + '%';
          }
        })
        .catch(function () {});
    }

    function injectAndUpdate() {
      if (!document.getElementById('pa-shipping-bar')) injectBar();
      updateBar();
    }

    function observe() {
      // Dawn has TWO render paths that wipe the bar:
      //   • CartDrawer.renderContents()  → replaces #CartDrawer.innerHTML
      //     (Add-to-cart from a product page). Direct children added are
      //     #CartDrawer-Overlay + .drawer__inner — NOT .drawer__header.
      //   • CartDrawerItems              → replaces .drawer__inner.innerHTML
      //     (quantity +/- inside the drawer). #CartDrawer's direct children
      //     don't change at all.
      // So we watch #CartDrawer with subtree:true to catch both, re-inject
      // whenever the bar was wiped, and always refresh. Mutations coming from
      // the bar's own inject/refresh are ignored to avoid a feedback loop.
      var container = document.getElementById('CartDrawer');
      if (container) {
        var observer = new MutationObserver(function (mutations) {
          var external = mutations.some(function (m) {
            return !(m.target.closest && m.target.closest('#pa-shipping-bar'));
          });
          if (!external) return;
          if (!document.getElementById('pa-shipping-bar')) {
            observer.disconnect();
            injectBar();
            observer.observe(container, { childList: true, subtree: true });
          }
          updateBar();
        });
        observer.observe(container, { childList: true, subtree: true });
      }

      // Re-inject / update when drawer is opened without a cart change
      // Dawn adds 'active' class via open() — no innerHTML change in that path
      var drawerEl = document.querySelector('cart-drawer');
      if (drawerEl) {
        new MutationObserver(function (mutations) {
          mutations.forEach(function (m) {
            if (m.attributeName === 'class' && drawerEl.classList.contains('active')) {
              injectAndUpdate();
            }
          });
        }).observe(drawerEl, { attributes: true, attributeFilter: ['class'] });
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        injectAndUpdate();
        observe();
      });
    } else {
      injectAndUpdate();
      observe();
    }
  }());

  /* ── INIT: sync bubble count on page load ─────────────────────── */
  refreshCartCount();

  /* ── SCROLL-TO-TOP ───────────────────────────────────────────── */
  var scrollBtn = document.getElementById('pa-scroll-top');
  if (scrollBtn) {
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function onPageScroll() {
      if (window.scrollY > 400) {
        scrollBtn.classList.add('is-visible');
      } else {
        scrollBtn.classList.remove('is-visible');
      }
    }

    window.addEventListener('scroll', onPageScroll, { passive: true });
    onPageScroll();

    scrollBtn.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: reduceMotion ? 'instant' : 'smooth' });
    });
  }

  // Wire nav cart button to Dawn's native cart drawer
  function openDawnCart() {
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && typeof cartDrawer.open === 'function') {
      cartDrawer.open();
      return;
    }
    // Fallback
    const dawnBtn = document.querySelector('[aria-controls="cart-drawer"]');
    if (dawnBtn) { dawnBtn.click(); return; }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      document.addEventListener('click', function(e) {
        if (e.target.closest('.pa-cart-btn')) {
          e.preventDefault();
          openDawnCart();
        }
      });
    });
  } else {
    document.addEventListener('click', function(e) {
      if (e.target.closest('.pa-cart-btn')) {
        e.preventDefault();
        openDawnCart();
      }
    });
  }

}());
